import { stats } from "@/mocks/dashan";

export default function Hero() {
  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 12% 20%, oklch(var(--accent-100)), transparent 34%), radial-gradient(circle at 85% 12%, oklch(var(--primary-100)), transparent 30%), radial-gradient(circle at 78% 80%, oklch(var(--secondary-100)), transparent 30%)",
        }}
      ></div>

      <div className="px-4 md:px-6 max-w-[1200px] mx-auto pt-24 md:pt-32 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 text-primary-700 text-xs md:text-sm font-medium animate-fadeUp">
              <i className="ri-fire-fill text-primary-500"></i>
              今日吃瓜 · 开场白套路研究所
            </span>

            <h2
              className="mt-5 md:mt-6 font-heading text-4xl md:text-6xl font-black leading-[1.12] text-foreground-950 animate-fadeUp"
              style={{ animationDelay: ".08s" }}
            >
              把尴尬咽下去，
              <br />
              把<span className="text-primary-600">心动</span>说出口
            </h2>

            <p
              className="mt-5 md:mt-6 text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl animate-fadeUp"
              style={{ animationDelay: ".16s" }}
            >
              搭讪吃瓜专注搭讪话术与开场白技巧——深扒套路、汇总金句、围观高手过招的真实聊天记录。
              不教你背台词，只教你读懂现场，避开尬聊雷区，把每一次开口都聊出温度。
            </p>

            <div
              className="mt-7 md:mt-8 flex flex-col sm:flex-row gap-3 animate-fadeUp"
              style={{ animationDelay: ".24s" }}
            >
              <button
                onClick={() => scrollTo("#opening")}
                className="px-6 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 whitespace-nowrap transition-colors cursor-pointer text-sm md:text-base"
              >
                去话术库挑一句
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
              <button
                onClick={() => scrollTo("#hot")}
                className="px-6 py-3.5 rounded-full bg-background-50 border border-background-300 text-foreground-800 font-medium hover:bg-background-100 whitespace-nowrap transition-colors cursor-pointer text-sm md:text-base"
              >
                先吃口热瓜
              </button>
            </div>

            <dl
              className="mt-10 md:mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 animate-fadeUp"
              style={{ animationDelay: ".32s" }}
            >
              {stats.map((s) => (
                <div key={s.label}>
                  <dd className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {s.num}
                  </dd>
                  <dt className="mt-1 text-xs md:text-sm text-foreground-500">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <div className="relative animate-float">
              <div className="relative rounded-[24px] overflow-hidden bg-background-50 border border-background-200 shadow-[0_18px_40px_-22px_rgba(0,0,0,0.25)]">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20illustration%20of%20two%20young%20friends%20chatting%20joyfully%20across%20a%20cafe%20table%20with%20coffee%20cups%2C%20speech%20bubbles%20floating%20between%20them%2C%20cream%20background%20with%20terracotta%20coral%20and%20warm%20gold%20accents%2C%20soft%20flat%20vector%20style%20with%20gentle%20texture%2C%20cozy%20and%20playful%20atmosphere&width=760&height=900&seq=hero-chat-01&orientation=portrait"
                  alt="两个朋友在咖啡馆开心聊天的杂志插画"
                  className="w-full h-[380px] md:h-[520px] object-cover"
                />
              </div>

              <div className="absolute -bottom-4 -left-4 md:-left-6 bg-primary-500 text-background-50 rounded-2xl px-4 py-3 md:px-5 md:py-4 max-w-[220px]">
                <p className="text-xs md:text-sm font-medium leading-snug">
                  别紧张，我又不吃人——不过你要是愿意，倒是可以吃个饭。
                </p>
                <p className="mt-1 text-[11px] md:text-xs text-background-200">
                  —— 本周最受欢迎金句
                </p>
              </div>

              <div className="absolute -top-4 -right-3 md:-right-5 bg-accent-500 text-background-50 rounded-full px-4 py-2 text-xs md:text-sm font-medium flex items-center gap-1.5">
                <i className="ri-fire-fill"></i> 46w 人在围观
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 跑马灯标签条 */}
      <div className="border-y border-background-200 bg-background-100/60 py-3 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee w-max">
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="flex items-center">
              {[
                "搭讪开场白",
                "话术套路深扒",
                "金句技巧讨论",
                "聊天记录围观",
                "避坑指南",
                "高手过招",
                "社交心理学",
                "约会话术",
              ].map((t) => (
                <span
                  key={t}
                  className="mx-5 flex items-center gap-2 text-sm text-foreground-600"
                >
                  <i className="ri-star-smile-fill text-accent-500"></i>
                  {t}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}